export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/pivotWorker.fa7ddd4b.worker.js");
}
